import { CommonSuccessResponse } from "constants/types/common";
import { RolePermission } from "constants/types/permission";
import useSWR from "swr";
import { serialize } from "utils/validation/string";

export const useDetailPermission = ({ role }: { role: string }) => {
  const {
    data,
    error,
    isLoading,
    mutate,
  }: {
    data: CommonSuccessResponse<RolePermission[]> | undefined;
    error: any;
    isLoading: boolean;
    mutate: any;
  } = useSWR(`/permission/role?${serialize({ role })}`, { refreshInterval: 0 });

  const detailPermission = data?.data;

  return {
    detailPermission,
    error,
    isLoading,
    mutate,
  };
};
